import { Button, Grid } from "@mui/material";
import React, { ChangeEvent } from "react";
import styles from "./survey.module.css";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { UploadPhotoThunk } from "../../redux/EnquiryForm/thunk";

function SurveyBodyPageTwo() {
    const dispatch = useDispatch<IRootThunkDispatch>();

    const { fileList } = useSelector(
        (state: IRootState) => state.enquiryFormInfoState
    );

    function handleUploadPhoto(event: ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        if (files) {
            // this is for single image
            const file = files[0];
            const filesArray = [file];

            // this is for multiple
            // const filesArray = Array.from(files);
            dispatch(UploadPhotoThunk(filesArray));
            return;
        }
    }

    return (
        <Grid>
            <Grid className={styles.PhotoRulesContainer}>
                <Grid>為妥善跟進個案，請上載回收相片</Grid>
                <Grid>
                    Please upload a photo of the recycling bin to facilitate
                    follow-up action:
                </Grid>
            </Grid>

            <ol start={5}>
                <li>
                    <Grid className={styles.OrderListContainer}>
                        <Grid>上載相片 Upload photos *</Grid>
                        <Grid>PNG,JPG,JPEG file types only</Grid>
                    </Grid>
                </li>
            </ol>

            <Grid>
                {fileList && fileList.length > 0 ? (
                    fileList.map((file, index) => (
                        <div
                            key={`photo-${index}`}
                            className={styles.PhotoContainer}
                        >
                            <img
                                width={"100%"}
                                height={"100%"}
                                src={URL.createObjectURL(file as File)}
                            />
                        </div>
                    ))
                ) : (
                    <></>
                )}
            </Grid>

            <div>
                <input
                    accept="image/*"
                    id="photo-upload-button"
                    type="file"
                    style={{ display: "none" }}
                    multiple
                    onChange={handleUploadPhoto}
                />
                <label htmlFor="photo-upload-button">
                    <Button
                        variant="contained"  
                        style={{ backgroundColor: "#00bf6f " ,marginTop:"20px"}}
                        component="span"
                        fullWidth
                    >
                        選擇或拍照相片 (choose a picture)
                    </Button>
                </label>
            </div>
        </Grid>
    );
}

export default SurveyBodyPageTwo;
